const noop = (): void => undefined;

const posthog = new Proxy({}, { get: () => noop }) as Record<
  string,
  () => void
>;

export default posthog;
export { posthog };
